import styled, { css } from 'styled-components';

import { withDecoratedScroll } from 'styles/common';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
`;

export const HeaderButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const Title = styled.h3`
  margin: 0;
  font-family: 'Share Tech Mono', monospace;
  font-size: 14px;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.8);
  text-transform: uppercase;
`;

export const SettingsButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    color: rgba(255, 255, 255, 0.9);
  }
`;

export const SearchWrapper = styled.div`
  position: relative;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 10px 40px 10px 10px;
  background: rgba(255, 255, 255, 0.04);
  border: none;
  border: 1px solid rgba(255, 255, 255, 0.06);
  outline: none;
  font-family: 'Share Tech Mono', monospace;
  font-size: 14px;
  color: #fff;

  &::placeholder {
    color: rgba(255, 255, 255, 0.25);
  }
`;

export const SearchClearButton = styled.button`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  border: none;
  color: rgba(255, 255, 255, 0.5);
  font-size: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    color: rgba(255, 255, 255, 0.9);
  }
`;

export const DividerLine = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(155, 89, 182, 0.15);
`;

export const FixedTokens = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 8px 0;
  gap: 6px;
`;

export const FixedTokenRemove = styled.button`
  opacity: 0;
  position: absolute;
  top: -5px;
  right: -5px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgba(255, 50, 50, 0.6);
  border: 1px solid rgba(255, 100, 100, 0.4);
  color: #fff;
  font-size: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.15s;

  &:hover {
    background: rgba(255, 50, 50, 0.8);
  }

  @media (max-width: 600px) {
    display: none;
  }
`;

export const FixedToken = styled.div`
  height: 30px;
  padding: 0 10px 0 4px;
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 99px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  position: relative;
  transition: 0.15s;

  span {
    font-family: 'Share Tech Mono', monospace;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
    max-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);

    ${FixedTokenRemove} {
      opacity: 1;
    }
  }
`;

export const TokenList = styled.div`
  ${withDecoratedScroll}
  max-height: 360px;
  margin: 0px -24px;
  width: calc(100% + 48px);
  flex: 1;
  overflow-y: auto;
  padding: 4px 0px;

  @media (max-width: 600px) {
    margin: 0px -16px;
    width: calc(100% + 32px);
  }
`;

export const TokenItem = styled.button<{ $isSelected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 20px 10px 24px;
  background: ${({ $isSelected }) => ($isSelected ? 'rgba(155, 89, 182, 0.15)' : 'transparent')};
  border: none;
  color: #fff;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
  }

  @media (max-width: 600px) {
    padding: 10px 12px 10px 16px;
  }
`;

export const TokenInfo = styled.div`
  flex: 1;
  min-width: 0;
  text-align: left;
`;

export const TokenSymbol = styled.div`
  margin-bottom: 2px;
  font-family: 'Share Tech Mono', monospace;
  font-size: 13px;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.9);

  a {
    color: rgba(255, 255, 255, 0.5);
    font-size: 10px;
    font-weight: normal;
    transition: 0.15s;

    &:hover {
      color: rgba(255, 255, 255, 0.9);
    }
  }
`;

export const TokenName = styled.div`
  font-family: 'Share Tech Mono', monospace;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.35);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  a {
    color: rgba(255, 255, 255, 0.35);
    transition: 0.15s;

    &:hover {
      color: rgba(255, 255, 255, 0.7);
    }
  }
`;

export const TokenBalanceCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
`;

export const TokenBalance = styled.div`
  font-family: 'Share Tech Mono', monospace;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
  text-align: right;
`;

export const TokenDollars = styled.div`
  font-family: 'Share Tech Mono', monospace;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  text-align: right;
`;

export const PinButton = styled.button<{ $isActive: boolean }>`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
  margin: -4px -4px -4px 4px;
  border-radius: 50%;
  font-size: 11px;
  color: ${({ $isActive }) => ($isActive ? 'rgba(155, 89, 182, 0.9)' : 'rgba(255, 255, 255, 0.2)')};
  transition: 0.15s;
  flex-shrink: 0;

  &:hover {
    color: ${({ $isActive }) =>
      $isActive ? 'rgba(255, 255, 255, 0.4)' : 'rgba(155, 89, 182, 0.9)'};
    background: rgba(255, 255, 255, 0.06);
  }
`;

export const RemoveButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
  margin-left: auto;
  border-radius: 50%;
  font-size: 13px;
  color: rgba(255, 100, 100, 0.7);
  transition: 0.15s;

  &:hover {
    color: rgba(255, 100, 100, 1);
    background: rgba(255, 255, 255, 0.06);
  }
`;

export const EmptyMessage = styled.div`
  padding: 32px 0;
  text-align: center;
  font-family: 'Share Tech Mono', monospace;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.3);
`;

export const ModalContent = styled.div<{ $hidden?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;

  ${({ $hidden }) =>
    $hidden &&
    css`
      display: none;
    `}
`;

export const SettingsContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
